/* eslint-disable max-len, react/no-array-index-key */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { Dropdown, Icon } from 'semantic-ui-react';
import _ from 'underscore';
import { Entity, convertToRaw } from 'draft-js';
import {
  PREFIX_BACKGROUND, PREFIX_COLOR, PREFIX_FONT, PREFIX_SIZE,
} from '../../constants';
import ComposerStyleButton from './ComposerStyleButton';
import ComposerColorPicker from './ComposerColorPicker';
import ComposerLinkInput from './ComposerLinkInput';
import { fontMediumColor } from '../../styles/palette';

const s = {
  styleControlBar: {
    borderRadius: '3px',
    color: fontMediumColor,
    flex: '1 1 auto',
    position: 'relative',
  },
  styleWrapper: {
    width: '100%',
    height: '100%',
    position: 'relative',
    margin: '0 auto',
    padding: '0.5rem 0',
  },
  styleButtons: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  test: {
    display: 'flex',
    alignItems: 'center',
  },
  selectedCheck: {
    minWidth: '2rem',
    fontSize: '0.8rem',
  },
  customIcon: {
    width: '2.2rem',
    height: '2rem',
    display: 'block',
  },
  dropdown: {
    position: 'relative',
    padding: '0.25rem',
    // width: '38px',
    // height: '38px',
    cursor: 'pointer',
    margin: '0.2rem',
    borderRadius: '3px',
    backgroundColor: 'rgb(186, 190, 199)',
    color: 'white',
    transition: 'all 0.3s ease',
    ':hover': {
      color: fontMediumColor,
      backgroundColor: 'white',
    },
  },
};

const STYLE_BUTTONS = [
  {
    iconName: '',
    style: 'FONT',
    type: 'FONT',
    description: 'Font Style',
  },
  {
    iconName: 'text height',
    style: 'SIZE',
    type: 'SIZE',
    description: 'Text Size',
  },
  {
    iconName: 'bold',
    style: 'BOLD',
    type: 'INLINE',
    description: 'Bold',
  },
  {
    iconName: 'italic',
    style: 'ITALIC',
    type: 'INLINE',
    description: 'Italicize',
  },
  {
    iconName: 'underline',
    style: 'UNDERLINE',
    type: 'INLINE',
    description: 'Underline',
  },
  {
    iconName: 'font',
    style: 'COLOR',
    type: PREFIX_COLOR,
    description: 'Text Color',
  },
  {
    iconName: 'adn',
    style: 'BACKGROUND',
    type: PREFIX_BACKGROUND,
    description: 'Background Color',
  },
  {
    iconName: 'linkify',
    style: 'LINK',
    type: 'ENTITY',
    description: 'Link',
    entity: 'LINK',
  },
  {
    iconName: 'camera',
    style: 'image',
    type: 'BLOCK',
    description: 'Insert an image',
  },
  {
    iconName: 'code',
    style: 'embed',
    type: 'BLOCK',
    description: 'Embed code',
  },
  {
    iconName: 'video camera',
    style: 'video',
    type: 'BLOCK',
    description: 'Upload video',
  },
  {
    iconName: 'ellipsis horizontal',
    style: 'more-info',
    type: 'BLOCK',
    description: 'Insert more info section',
  },
  {
    iconName: (
      <div style={s.customIcon}>
        <svg width="100%" height="100%" viewBox="0 2 20 10">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-4.000000, -6.000000)">
              <g transform="translate(4.000000, 6.000000)">
                <path
                  d="M15,14 L8.98570456,14 L8.98570456,13.2995067 C9.14908182,13.2863518 9.38563494,13.2666198 9.695371,13.2403101 C10.0051071,13.2140003 10.2178347,13.1745363 10.3335602,13.1219168 C10.5377818,13.0429876 10.6875421,12.9229512 10.7828455,12.7618041 C10.8781489,12.6006569 10.9257999,12.3918265 10.9257999,12.1353066 L10.9257999,7.15292459 L4.11504425,7.15292459 L4.11504425,12.0267794 C4.11504425,12.2569896 4.15418613,12.4510211 4.23247107,12.6088795 C4.31075601,12.7667379 4.46562172,12.904862 4.69707284,13.0232558 C4.8127984,13.0824527 5.01871874,13.1416488 5.31484003,13.2008457 C5.61096132,13.2600426 5.84411079,13.2929293 6.01429544,13.2995067 L6.01429544,14 L1.77635684e-15,14 L1.77635684e-15,13.2995067 C0.163377263,13.2863518 0.399930378,13.2666198 0.70966644,13.2403101 C1.0194025,13.2140003 1.23213012,13.1745363 1.34785568,13.1219168 C1.55207726,13.0429876 1.70183751,12.9229512 1.79714091,12.7618041 C1.89244432,12.6006569 1.9400953,12.3918265 1.9400953,12.1353066 L1.9400953,2.0324172 C1.9400953,1.82193928 1.89584796,1.6295522 1.80735194,1.45525018 C1.71885592,1.28094815 1.56569204,1.14446843 1.34785568,1.04580691 C1.16405626,0.960300254 0.941117716,0.884660888 0.679033356,0.81888654 C0.416948996,0.753112192 0.190606807,0.713648175 1.77635684e-15,0.700493305 L1.77635684e-15,0 L6.01429544,0 L6.01429544,0.700493305 C5.82368863,0.70707074 5.59053916,0.736668753 5.31484003,0.789288231 C5.0391409,0.84190771 4.83322056,0.891237731 4.69707284,0.937279774 C4.46562172,1.01620899 4.31075601,1.14775572 4.23247107,1.33192389 C4.15418613,1.51609206 4.11504425,1.71670082 4.11504425,1.93375617 L4.11504425,6.27484144 L10.9257999,6.27484144 L10.9257999,2.0324172 C10.9257999,1.82193928 10.8815525,1.6295522 10.7930565,1.45525018 C10.7045605,1.28094815 10.5513966,1.14446843 10.3335602,1.04580691 C10.1497608,0.960300254 9.92682228,0.884660888 9.66473792,0.81888654 C9.40265356,0.753112192 9.17631137,0.713648175 8.98570456,0.700493305 L8.98570456,0 L15,0 L15,0.700493305 C14.8093932,0.70707074 14.5762437,0.736668753 14.3005446,0.789288231 C14.0248455,0.84190771 13.8189251,0.891237731 13.6827774,0.937279774 C13.4513263,1.01620899 13.2964606,1.14775572 13.2181756,1.33192389 C13.1398907,1.51609206 13.1007488,1.71670082 13.1007488,1.93375617 L13.1007488,12.0267794 C13.1007488,12.2569896 13.1398907,12.4510211 13.2181756,12.6088795 C13.2964606,12.7667379 13.4513263,12.904862 13.6827774,13.0232558 C13.798503,13.0824527 14.0044233,13.1416488 14.3005446,13.2008457 C14.5966659,13.2600426 14.8298154,13.2929293 15,13.2995067 L15,14 Z"
                  id="H"
                  fill="#000000"
                />
                <path
                  d="M19.4501953,14 L16.1591797,14 L16.1591797,13.6533203 C16.2568364,13.6468099 16.4090159,13.6329754 16.6157227,13.6118164 C16.8224294,13.5906574 16.9648434,13.568685 17.0429688,13.5458984 C17.1438807,13.5133462 17.2211911,13.4604496 17.2749023,13.387207 C17.3286135,13.3139645 17.3554688,13.2041023 17.3554688,13.0576172 L17.3554688,9.62988281 L16.1396484,9.62988281 L16.1396484,9.21972656 L16.4082031,9.21972656 C16.7597674,9.21972656 17.0747056,9.15462305 17.3530273,9.02441406 C17.631349,8.89420508 17.8307286,8.75423252 17.9511719,8.60449219 L18.3564453,8.60449219 C18.3466796,8.81608179 18.3369141,9.06347515 18.3271484,9.34667969 C18.3173828,9.62988423 18.3125,9.88378794 18.3125,10.1083984 L18.3125,13.0039062 C18.3125,13.1178391 18.3377276,13.2195634 18.3881836,13.309082 C18.4386396,13.3986007 18.5110672,13.464518 18.6054688,13.5068359 C18.6901046,13.5426434 18.8284496,13.5751952 19.0205078,13.6044922 C19.2125661,13.6337892 19.3557938,13.6500651 19.4501953,13.6533203 L19.4501953,14 Z"
                  id="1"
                  fill="#000000"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
    ),
    custom: true,
    style: 'header-one',
    type: 'BLOCK',
    description: 'Heading One',
  },
  {
    iconName: (
      <div style={s.customIcon}>
        <svg width="100%" height="100%" viewBox="0 2 20 10">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-4.000000, -6.000000)">
              <g transform="translate(4.000000, 6.000000)">
                <path
                  d="M15,14 L8.98570456,14 L8.98570456,13.2995067 C9.14908182,13.2863518 9.38563494,13.2666198 9.695371,13.2403101 C10.0051071,13.2140003 10.2178347,13.1745363 10.3335602,13.1219168 C10.5377818,13.0429876 10.6875421,12.9229512 10.7828455,12.7618041 C10.8781489,12.6006569 10.9257999,12.3918265 10.9257999,12.1353066 L10.9257999,7.15292459 L4.11504425,7.15292459 L4.11504425,12.0267794 C4.11504425,12.2569896 4.15418613,12.4510211 4.23247107,12.6088795 C4.31075601,12.7667379 4.46562172,12.904862 4.69707284,13.0232558 C4.8127984,13.0824527 5.01871874,13.1416488 5.31484003,13.2008457 C5.61096132,13.2600426 5.84411079,13.2929293 6.01429544,13.2995067 L6.01429544,14 L1.77635684e-15,14 L1.77635684e-15,13.2995067 C0.163377263,13.2863518 0.399930378,13.2666198 0.70966644,13.2403101 C1.0194025,13.2140003 1.23213012,13.1745363 1.34785568,13.1219168 C1.55207726,13.0429876 1.70183751,12.9229512 1.79714091,12.7618041 C1.89244432,12.6006569 1.9400953,12.3918265 1.9400953,12.1353066 L1.9400953,2.0324172 C1.9400953,1.82193928 1.89584796,1.6295522 1.80735194,1.45525018 C1.71885592,1.28094815 1.56569204,1.14446843 1.34785568,1.04580691 C1.16405626,0.960300254 0.941117716,0.884660888 0.679033356,0.81888654 C0.416948996,0.753112192 0.190606807,0.713648175 1.77635684e-15,0.700493305 L1.77635684e-15,0 L6.01429544,0 L6.01429544,0.700493305 C5.82368863,0.70707074 5.59053916,0.736668753 5.31484003,0.789288231 C5.0391409,0.84190771 4.83322056,0.891237731 4.69707284,0.937279774 C4.46562172,1.01620899 4.31075601,1.14775572 4.23247107,1.33192389 C4.15418613,1.51609206 4.11504425,1.71670082 4.11504425,1.93375617 L4.11504425,6.27484144 L10.9257999,6.27484144 L10.9257999,2.0324172 C10.9257999,1.82193928 10.8815525,1.6295522 10.7930565,1.45525018 C10.7045605,1.28094815 10.5513966,1.14446843 10.3335602,1.04580691 C10.1497608,0.960300254 9.92682228,0.884660888 9.66473792,0.81888654 C9.40265356,0.753112192 9.17631137,0.713648175 8.98570456,0.700493305 L8.98570456,0 L15,0 L15,0.700493305 C14.8093932,0.70707074 14.5762437,0.736668753 14.3005446,0.789288231 C14.0248455,0.84190771 13.8189251,0.891237731 13.6827774,0.937279774 C13.4513263,1.01620899 13.2964606,1.14775572 13.2181756,1.33192389 C13.1398907,1.51609206 13.1007488,1.71670082 13.1007488,1.93375617 L13.1007488,12.0267794 C13.1007488,12.2569896 13.1398907,12.4510211 13.2181756,12.6088795 C13.2964606,12.7667379 13.4513263,12.904862 13.6827774,13.0232558 C13.798503,13.0824527 14.0044233,13.1416488 14.3005446,13.2008457 C14.5966659,13.2600426 14.8298154,13.2929293 15,13.2995067 L15,14 Z"
                  id="H"
                  fill="#000000"
                />
                <path
                  d="M19.7000008,14.02 L16.2000008,14.02 L16.2000008,13.4390769 C16.267237,13.350799 16.3606192,13.2518437 16.4801502,13.1422082 C16.5996812,13.0325726 16.7416221,12.9136839 16.9059773,12.7855385 C17.0055865,12.7086512 17.1251157,12.624646 17.2645685,12.5335204 C17.4040214,12.4423948 17.5621486,12.3427276 17.7389549,12.2345159 C17.935683,12.1149135 18.0869622,12.0095511 18.1927969,11.9184254 C18.2986317,11.8272998 18.3951266,11.7148182 18.4822846,11.5809775 C18.5395599,11.4926995 18.5856285,11.3823537 18.6204917,11.2499368 C18.6553549,11.1175198 18.6727862,10.9288641 18.6727862,10.6839639 C18.6727862,10.3280044 18.5893648,10.066734 18.4225194,9.90014496 C18.2556741,9.7335559 18.0415175,9.65026262 17.7800435,9.65026262 C17.6181785,9.65026262 17.4650317,9.68656995 17.3205984,9.75918569 C17.1761651,9.83180144 17.0678418,9.93218052 16.9956251,10.0603259 C17.0130567,10.1514516 17.0348459,10.2596617 17.0609933,10.3849594 C17.0871407,10.5102572 17.1002142,10.6327054 17.1002142,10.7523078 C17.1002142,10.8605195 17.0609937,10.9566271 16.9825515,11.0406336 C16.9041092,11.12464 16.7876927,11.1666426 16.6332985,11.1666426 C16.508787,11.1666426 16.4129147,11.117521 16.3456785,11.0192761 C16.2784423,10.9210313 16.2448247,10.7893283 16.2448247,10.624163 C16.2448247,10.4703885 16.2821776,10.3159044 16.3568844,10.160706 C16.4315913,10.0055077 16.5386696,9.86241409 16.6781224,9.73142099 C16.815085,9.60327555 16.9844181,9.49933693 17.1861267,9.419602 C17.3878353,9.33986706 17.6057271,9.30000019 17.8398087,9.30000019 C18.3503057,9.30000019 18.7555845,9.43027943 19.0556571,9.6908418 C19.3557298,9.95140418 19.5057638,10.2995274 19.5057638,10.7352218 C19.5057638,10.9431022 19.4789943,11.1324698 19.4254543,11.3033304 C19.3719144,11.474191 19.2853802,11.6251156 19.1658492,11.7561087 C19.0338671,11.9013402 18.8794751,12.0259241 18.7026689,12.1298643 C18.5258626,12.2338045 18.2556767,12.3783219 17.8921032,12.5634209 C17.6754533,12.6744802 17.4737477,12.7905213 17.2869805,12.9115475 C17.1002133,13.0325738 16.9470665,13.1500387 16.8275354,13.2639457 L19.7000008,13.2639457 L19.7000008,14.02 Z"
                  id="2"
                  fill="#000000"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
    ),
    custom: true,
    style: 'header-two',
    type: 'BLOCK',
    description: 'Heading Two',
  },
  {
    iconName: 'list ul',
    style: 'unordered-list-item',
    type: 'BLOCK',
    description: 'Bulleted list',
  },
  {
    iconName: 'list ol',
    style: 'ordered-list-item',
    type: 'BLOCK',
    description: 'Numbered list',
  },
  {
    iconName: 'terminal',
    style: 'code-block',
    type: 'BLOCK',
    description: 'Code Block',
  },
  {
    iconName: 'quote right',
    style: 'blockquote',
    type: 'BLOCK',
    description: 'Blockquote',
  },
];

class ComposerStyleControl extends Component {
  static defaultProps = {
    editorState: {},
    toggleInlineType: () => {},
    toggleCustomStyle: () => {},
    toggleBlockType: () => {},
    addLinkEntity: () => {},
    removeLinkEntity: () => {},
  };

  static propTypes = {
    editorState: PropTypes.object,
    toggleInlineType: PropTypes.func,
    toggleCustomStyle: PropTypes.func,
    addLinkEntity: PropTypes.func,
    removeLinkEntity: PropTypes.func,
    toggleBlockType: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      displayLinkInput: false,
      displayColorPicker: false,
      displayBackgroundColorPicker: false,
      displayTextSizeDropdown: false,
    };
    this.toggleColorButton = this.toggleColorButton.bind(this);
    this.toggleBackgroundColorPicker = this.toggleBackgroundColorPicker.bind(this);
    this.toggleColorPicker = this.toggleColorPicker.bind(this);
    this.toggleFontStyle = this.toggleFontStyle.bind(this);
    this.toggleTextSize = this.toggleTextSize.bind(this);
    this.toggleTextSizeButton = this.toggleTextSizeButton.bind(this);
    this.closeFontSizeModal = this.closeFontSizeModal.bind(this);
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps() {
    // This will force the link input field to hide when you make a new selection.
    // We don't want it to remain if you had opened it, and then move on to a different part of the editor
    const currentSelection = this.props.editorState.getSelection();
    if (currentSelection && !currentSelection.hasFocus) {
      this.setState({
        displayLinkInput: false,
        displayColorPicker: false,
        displayBackgroundColorPicker: false,
      });
    }
  }

  get currentStyle() {
    return this.props.editorState.getCurrentInlineStyle();
  }

  get currentStyleList() {
    // eslint-disable-next-line no-underscore-dangle
    const currentStyle = this.currentStyle._map._map._root;
    if (currentStyle) {
      return currentStyle.entries;
    }
    return null;
  }

  defaultStyle(prefix) {
    let defaultStyle = '';
    const prefixLength = prefix.length;
    // get list of styles that are currently applied to the selected text
    const currentStyleList = this.currentStyleList;
    if (currentStyleList) {
      // loop over all current styles to see if there is a current style matching the prefix passed in
      currentStyleList.forEach((styleItem) => {
        const styleItemPrefix = styleItem[0].slice(0, prefixLength);
        if (styleItemPrefix === prefix) {
          // if matching prefix found, assign defaultStyle the value without the prefix
          defaultStyle = styleItem[0].slice(prefixLength);
        }
      });
      return defaultStyle;
    }
    return null;
  }

  get currentBlock() {
    const selection = this.props.editorState.getSelection();
    const currentBlock = this.props.editorState
      .getCurrentContent()
      .getBlockForKey(selection.getStartKey());

    return currentBlock;
  }

  get blockType() {
    return this.currentBlock.getType();
  }

  get hasMoreInfo() {
    const { editorState } = this.props;
    const entityMap = convertToRaw(editorState.getCurrentContent()).entityMap;
    const hasMoreInfo = _.some(
      Object.values(entityMap),
      (entry) => entry.data.type === 'more-info',
    );
    return hasMoreInfo;
  }

  get filteredStyleButtons() {
    const props = this.props;
    const styleButtons = _.compact(
      STYLE_BUTTONS.map((data) => {
        if (data.type === 'BLOCK') {
          return {
            iconName: data.iconName,
            custom: data.custom,
            style: data.style,
            description: data.description,
            active: data.style === this.blockType,
            action: props.toggleBlockType,
          };
        }
        if (data.type === 'INLINE') {
          return {
            iconName: data.iconName,
            custom: data.custom,
            style: data.style,
            description: data.description,
            active: this.currentStyle.has(data.style),
            action: props.toggleInlineType,
          };
        }
        if (data.type === 'FONT') {
          return {
            iconName: data.iconName,
            custom: data.custom,
            style: data.style,
            description: data.description,
            active: false,
            action: this.toggleFontStyleButton,
          };
        }
        if (data.type === 'SIZE') {
          return {
            iconName: data.iconName,
            custom: data.custom,
            style: data.style,
            description: data.description,
            active: this.state.displayTextSizeDropdown,
            action: this.toggleTextSizeButton,
          };
        }
        if (data.type === PREFIX_COLOR) {
          return {
            iconName: data.iconName,
            custom: data.custom,
            style: data.style,
            description: data.description,
            active: this.state.displayColorPicker,
            action: this.toggleColorButton,
          };
        }
        if (data.type === PREFIX_BACKGROUND) {
          return {
            iconName: data.iconName,
            custom: data.custom,
            style: data.style,
            description: data.description,
            active: this.state.displayBackgroundColorPicker,
            action: this.toggleColorButton,
          };
        }
        if (data.type === 'ENTITY') {
          const { entity } = data;

          // Example of toggling link entity via Megadraft:
          // https://github.com/globocom/megadraft/blob/08bce357573ea251b3a29308e12a7e34f2e868f4/src/components/Toolbar.js
          return {
            iconName: data.iconName,
            custom: data.custom,
            style: data.style,
            description: data.description,
            active: this.hasEntity(entity),
            action: this.toggleInputField.bind(this),
            entity: data.entity,
          };
        }
        return null;
      }),
    );

    const filteredStyleButtons = styleButtons.filter((data) => {
      if (this.currentBlock.getText().trim() === '') {
        if (
          data.style !== 'BOLD'
          && data.style !== 'ITALIC'
          && data.style !== 'UNDERLINE'
          && data.style !== 'LINK'
          && data.style !== 'BACKGROUND'
          && data.style !== 'COLOR'
        ) {
          if (data.style !== 'more-info' || this.hasMoreInfo === false) {
            return data;
          }
        }
      } else if (
        data.style !== 'image'
        && data.style !== 'embed'
        && data.style !== 'more-info'
        && data.style !== 'video'
      ) {
        return data;
      }
      return false;
    });

    // For each button we return the ComposerStyleButton component
    // to attach the modal for the text/bg color picker we send the modal
    // component to CompoersStyleButton, which calls props.children
    // this allows us to absolute style the modal relative to the button.
    // NOTE: this.backgroundColorPickerModal and this.colorPickerModal
    // are separate functions even though they are calling the same
    // component because joining them creates double modals when button is toggled
    return filteredStyleButtons.map((item, i) => {
      if (item.style === 'BACKGROUND') {
        return (
          <ComposerStyleButton
            key={i}
            active={item.active}
            description={item.description}
            iconName={item.iconName}
            custom={item.custom}
            onToggle={item.action}
            buttonStyle={item.style}
          >
            {this.backgroundColorPickerModal}
          </ComposerStyleButton>
        );
      }
      if (item.style === 'COLOR') {
        return (
          <ComposerStyleButton
            key={i}
            active={item.active}
            description={item.description}
            iconName={item.iconName}
            custom={item.custom}
            onToggle={item.action}
            buttonStyle={item.style}
          >
            {this.colorPickerModal}
          </ComposerStyleButton>
        );
      }
      if (item.style === 'SIZE') {
        const defaultStyle = this.defaultStyle(PREFIX_SIZE);
        const textSize = defaultStyle || '';
        const SIZES = ['12px', '16px', '20px', '24px'].map((size) => ({
          key: size,
          value: size,
          text: size,
        }));
        // SIZES = [{
        //   key: 'default',
        //   value: 'default',
        //   icon: 'text height',
        // }, ...SIZES];
        // Return a component with a list of items for the dropdown selection
        return (
          <Dropdown
            value={textSize}
            key={i}
            options={SIZES}
            style={s.dropdown}
            icon={null}
            placeholder={<Icon name="text height" style={{ color: 'white' }} size="large" />}
            onChange={(e, { value }) => this.toggleTextSize(value)}
            onMouseDown={(e) => {
              // This is real dumb, but it does what I want it to
              if (e.target.tagName === 'SPAN' || e.target.getAttribute('role', null) === 'option') {
                this.toggleTextSize(e.target.textContent);
                // This next line can't possibly do anything, but it works for some reason,
                // even though it generates an error. No, I don't know why,
                // but I'm sick of staring at it, and I'm going to burn it down anyway
                this.editor.focus();
              }
              e.preventDefault();
            }}
          />
        );
      }
      if (item.style === 'FONT') {
        const defaultStyle = this.defaultStyle(PREFIX_FONT);
        const fontName = defaultStyle || 'Font Style';

        // Return a component with a list of items for the dropdown selection
        // selected style is a prop passed down to the Dropdown menu that is
        // used to verify if a check should be next to that font
        // dataId is a prop passed down to the Dropdown menu to display to
        // match selected style and display the font name in list
        // StyleMap has FONT_Sans Serif --> this.defaultStyle will return
        // Sans Serif --> this will match dataId Sans Serif if it is selected
        // --> we adjust the css font to Sans-serif in the css of the list dropdown
        const FONTS = [
          'Font Style',
          'Georgia',
          'Hoefler Text',
          'Monospace',
          'Serif',
          'Sans Serif',
          'Tahoma',
          'Trebuchet MS',
          'Verdana',
        ].map((font) => ({
          key: font.replace(' ', '').toLowerCase(),
          value: font,
          text: font,
        }));
        return (
          <Dropdown
            style={s.dropdown}
            key={i}
            // open={this.state.open}
            value={fontName}
            options={FONTS}
            onChange={(e, { value }) => this.toggleFontStyle(value)}
            onMouseDown={(e) => {
              // This is real dumb, but it does what I want it to
              if (e.target.tagName === 'SPAN' || e.target.getAttribute('role', null) === 'option') {
                this.toggleFontStyle(e.target.textContent);
                // This next line can't possibly do anything, but it works for some reason,
                // even though it generates an error. No, I don't know why,
                // but I'm sick of staring at it, and I'm going to burn it down anyway
                this.editor.focus();
              }
              e.preventDefault();
            }}
          />
        );
      }
      return (
        <ComposerStyleButton
          key={i}
          active={item.active}
          description={item.description}
          iconName={item.iconName}
          custom={item.custom}
          onToggle={item.action}
          buttonStyle={item.style}
        />
      );
    });
  }

  /**
   * Each time the link field is clicked, the field for the link will open/close
   * @param  {object} data [description]
   * @return {[type]}      [description]
   */
  toggleInputField() {
    const displayLinkInput = !this.state.displayLinkInput;

    this.setState({
      displayLinkInput,
    });
  }

  /**
   * Each time the text/background field is clicked, the color picker modal will open/close
   * @param  {object} data [description]
   * @return {[type]}      [description]
   */
  // BACKGROUND COLOR/TEXT COLOR TOGGLE FUNCTIONS
  toggleColorButton(data) {
    if (data === 'BACKGROUND') {
      if (this.state.displayColorPicker) {
        // if someone clicked between the text/background color buttons, close the previous color picker modal
        this.toggleColorPicker();
      }

      if (this.state.displayBackgroundColorPicker) {
        // we don't want to toggle the color picker if it is already open
        // this is because a click on the color picker fires the button toggle action,
        // but we want to capture the color chosen before toggling
      } else {
        this.toggleBackgroundColorPicker();
      }
    } else if (data === 'COLOR') {
      if (this.state.displayBackgroundColorPicker) {
        // if someone clicked between the text/background color buttons, close the previous color picker modal
        this.toggleBackgroundColorPicker();
      }

      if (this.state.displayColorPicker) {
        // we don't want to toggle the color picker if it is already open
        // this is because a click on the color picker fires the button toggle action,
        // but we want to capture the color chosen before toggling
      } else {
        this.toggleColorPicker();
      }
    }
  }

  toggleTextSizeButton() {
    // If the modal is open we do not want to close it until we click close or toggle fontSize
    if (this.state.displayTextSizeDropdown === true) {
      return;
    }
    this.setState({ displayTextSizeDropdown: true });
  }

  closeFontSizeModal() {
    this.setState({ displayTextSizeDropdown: false });
  }

  toggleFontStyle(font) {
    this.props.toggleCustomStyle(font, PREFIX_FONT);
  }

  toggleTextSize(size) {
    // extract fonts further into contstants
    this.props.toggleCustomStyle(size, PREFIX_SIZE);
  }

  toggleColorPicker() {
    const displayColorPicker = !this.state.displayColorPicker;

    this.setState({
      displayColorPicker,
    });
  }

  toggleBackgroundColorPicker() {
    const displayBackgroundColorPicker = !this.state.displayBackgroundColorPicker;

    this.setState({
      displayBackgroundColorPicker,
    });
  }

  get colorPickerModal() {
    if (this.state.displayColorPicker) {
      const defaultStyle = this.defaultStyle(PREFIX_COLOR);
      const color = defaultStyle || '#000000';
      return (
        <ComposerColorPicker
          toggleStyle={PREFIX_COLOR}
          toggleModal={this.toggleColorPicker}
          toggleStyleFn={this.props.toggleCustomStyle}
          color={color}
          title="Text Color"
        />
      );
    }
    return null;
  }

  get backgroundColorPickerModal() {
    if (this.state.displayBackgroundColorPicker) {
      const defaultStyle = this.defaultStyle(PREFIX_BACKGROUND);
      const color = defaultStyle || '#ffffff';

      return (
        <ComposerColorPicker
          toggleStyle={PREFIX_BACKGROUND}
          toggleStyleFn={this.props.toggleCustomStyle}
          toggleModal={this.toggleBackgroundColorPicker}
          color={color}
          title="Backgound Color"
        />
      );
    }
    return null;
  }

  get currentEntityKey() {
    const selection = this.props.editorState.getSelection();
    const anchorKey = selection.getAnchorKey();
    const contentState = this.props.editorState.getCurrentContent();
    const anchorBlock = contentState.getBlockForKey(anchorKey);
    const offset = selection.anchorOffset;
    const index = selection.isBackward ? offset - 1 : offset;
    return anchorBlock.getEntityAt(index);
  }

  get currentEntity() {
    const entityKey = this.currentEntityKey;
    if (entityKey) {
      return Entity.get(entityKey);
    }
    return null;
  }

  get entityUrl() {
    // A link is a type of entity, and if the type is 'LINK', it should have url
    const entity = this.currentEntity;
    if (entity && entity.getType() === 'LINK') {
      return entity.data.url;
    }
    return null;
  }

  /**
   * Checks if the current selection has an entity of the type passed in as a param
   * @param  {string}  entityType - i.e. 'LINK'
   * @return {Boolean}
   */
  hasEntity(entityType) {
    const entity = this.currentEntity;
    if (entity && entity.getType() === entityType) {
      return true;
    }
    return false;
  }

  /**
   * [linkInput description]
   * @return {[type]} [description]
   */
  get linkInput() {
    if (this.state.displayLinkInput) {
      return (
        <ComposerLinkInput
          addLinkEntity={this.props.addLinkEntity}
          removeLinkEntity={this.props.removeLinkEntity}
          hasLink={this.hasEntity('LINK')}
          displayInput={this.state.displayLinkInput}
          currentLink={this.entityUrl}
        />
      );
    }
    return null;
  }

  render() {
    return (
      <div style={s.styleControlBar}>
        <div style={s.styleWrapper}>
          <div style={s.styleButtons}>{this.filteredStyleButtons}</div>
        </div>
        {this.linkInput}
      </div>
    );
  }
}

export default Radium(ComposerStyleControl);
